var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as brokerSelectors from "../../redux/broker/broker.selectors";
import { createContact, createContactBroker, updateContact, updateContactBroker, } from "../../redux/contact/contact.actions";
import { EContactCustomId } from "../../redux/contact/contact.types";
import { REDUCER_KEY_EXTERNAL_ACTION } from "../../reduxV2/externalAction";
import * as externalActionActions from "../../reduxV2/externalAction/externalAction.actions";
import { getContact } from "./schema.addContact.actions.utils";
import { EField } from "./schema.addContact.types";
export var isPerformingSubmitActionSelector = function (contactId) { return function (state) {
    if (contactId) {
        var updateState = state.contact.contactsById[contactId];
        if (updateState) {
            return updateState.isUpdating || false;
        }
        return false;
    }
    return state.contact.isCreatingContact;
}; };
export var performingSubmitActionResultSelector = function (contactId) { return function (state) {
    if (contactId) {
        // TODO: Check
        var me = state.contact.data[EContactCustomId.Me];
        if (me && me.id === contactId) {
            return me;
        }
        return state.contact.data[contactId];
    }
    return state.contact.createdContact;
}; };
export var performingSubmitActionErrorSelector = function (contactId) { return function (state) {
    if (contactId) {
        var updateState = state.contact.contactsById[contactId];
        if (updateState) {
            return updateState.updateError;
        }
        return;
    }
    return state.contact.createContactError;
}; };
export var submitActionCreator = function (contactId, baseAccountId, prefilledAddress, optionalFields) {
    return function (formData) {
        var contact = getContact(formData, contactId, baseAccountId, prefilledAddress, optionalFields);
        if (contactId) {
            return updateContact.actions.start({ contactId: contactId, contact: contact });
        }
        var sendInvite = !(formData[EField.SendInvite] === "no");
        return createContact.actions.start({
            contact: contact,
            sendInvite: sendInvite,
        });
    };
};
export var performingSubmitBrokerActionResultSelector = function (brokerId, customId) {
    return function (state) {
        var contact = state.contact.createdContact;
        if (customId) {
            contact = state.contact.data[customId];
        }
        var broker = brokerSelectors.detail.detail(state, brokerId);
        return {
            contact: contact,
            broker: broker,
        };
    };
};
export var submitBrokerContactActionCreator = function (brokerId, customId, contactId) {
    return function (formData) {
        var contact = getContact(formData);
        var IDCardFront = formData.IDCardFront, IDCardBack = formData.IDCardBack;
        if (contactId) {
            return updateContactBroker.actions.start({
                brokerId: brokerId,
                contactId: contactId,
                customId: customId,
                data: contact,
            });
        }
        return createContactBroker.actions.start({
            brokerId: brokerId,
            customId: customId,
            contact: contact,
            IDCardFrontside: IDCardFront ? IDCardFront[0] : undefined,
            IDCardBackside: IDCardBack ? IDCardBack[0] : undefined,
        });
    };
};
export var isPerformingSubmitExternalActionSelector = function (type) { return function (state) {
    if (!type) {
        return false;
    }
    var updateState = state[REDUCER_KEY_EXTERNAL_ACTION]
        ? state[REDUCER_KEY_EXTERNAL_ACTION].externalAction[type]
        : undefined;
    if (updateState) {
        return updateState.isPending || false;
    }
    return false;
}; };
export var performingSubmitExternalActionResultSelector = function (contactId) { return function (state) {
    return true;
}; };
export var performingSubmitExternalActionErrorSelector = function (type) { return function (state) {
    if (!type) {
        return false;
    }
    var updateState = state[REDUCER_KEY_EXTERNAL_ACTION]
        ? state[REDUCER_KEY_EXTERNAL_ACTION].externalAction[type]
        : undefined;
    if (updateState) {
        return updateState.error || false;
    }
    return false;
}; };
export var submitExternalActionCreator = function (type, externalActionId, externalActionKey, token) {
    return function (formData) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        var idCardFrontside = formData[EField.IdentityFrontDocument];
        var idCardBackside = formData[EField.IdentityBackDocument];
        var data = __assign(__assign({ updateContactDto: {
                // @ts-ignore
                firstName: formData.firstname,
                // @ts-ignore
                lastName: formData.lastname,
                email: formData.email,
                phone: formData.phone,
                // locale: formData.locale,
                foreignIdentityNumber: formData.foreignIdentityNumber || null,
                nationalRegisterNumber: formData.nationalRegisterNumber || null,
                dateOfBirth: formData.dateOfBirth,
                nationality: formData.nationality,
                placeOfBirth: (_a = formData.placeOfBirth) === null || _a === void 0 ? void 0 : _a.city,
                countryOfBirth: (_b = formData.placeOfBirth) === null || _b === void 0 ? void 0 : _b.country,
                countryId: (_c = formData.address) === null || _c === void 0 ? void 0 : _c.country,
                street: (_d = formData.address) === null || _d === void 0 ? void 0 : _d.street,
                number: (_e = formData.address) === null || _e === void 0 ? void 0 : _e.number,
                box: (_f = formData.address) === null || _f === void 0 ? void 0 : _f.box,
                zip: (_g = formData.address) === null || _g === void 0 ? void 0 : _g.zip,
                city: (_h = formData.address) === null || _h === void 0 ? void 0 : _h.city,
                state: (_j = formData.address) === null || _j === void 0 ? void 0 : _j.state,
            } }, ((idCardFrontside === null || idCardFrontside === void 0 ? void 0 : idCardFrontside[0]) && { IDCardFront: idCardFrontside[0] })), ((idCardBackside === null || idCardBackside === void 0 ? void 0 : idCardBackside[0]) && { IDCardBack: idCardBackside[0] }));
        if (externalActionId && externalActionKey && type && token) {
            return externalActionActions.performExternalActionStart.getAction({
                id: externalActionId,
                key: externalActionKey,
                type: type,
                data: data,
                token: token,
                onSuccess: function () { },
            });
        }
        return;
    };
};
